import React from 'react';
import './Events.css';

import { Event, Heading } from '../../../components';
import { events } from '../../../constants';



const Events = () => {  
  return (

    <section className='events'>

      {/* Section heading */}
      <Heading title={'Our Events'} subTitle={'Join Our Upcoming Events'} />

      <div className='box-container'>
        {/* Show only the top 2 events */}
        {events.slice(0, 2).map((event) => (
          <Event key={event.id} event={event} />
        ))}
      </div>

    </section>

  );
}

export default Events;